import $ from 'jquery';
import BaseController from './BaseController';

class CartController extends BaseController {

    initActions() {
        super.initActions();
        this.actions.addAction('cart_updated', this.onCartUpdated.bind(this), 20);
        this.actions.addAction('shipping_method_changed', this.onShippingSelected.bind(this));
    }

    async onCartUpdated(cart) {
        try {
            if (this.gateway.isPaymentSheetOpen()) {
                return;
            }
            if (cart.hasChanged('needsShipping')) {
                this.gateway.destroyPaymentElement();
            }
            // Reload Stripe SDK (will get new instance if params changed)
            await this.loadStripeSDK();

            // Recreate payment element with updated data
            await this.createPaymentElement();

        } catch (error) {
            console.error('Error reloading payment elements:', error);
        }
    }

    onPaymentElementReady() {
        super.onPaymentElementReady();
        $(`li.payment_method_${this.gateway.id}`).show();
        $('.wc_stripe_cart_payment_methods').addClass('active');
    }

    onPaymentUnavailable() {
        super.onPaymentUnavailable();
        $(`li.payment_method_${this.gateway.id}`).hide();
    }

    onShippingSelected() {
        this.storeAttributionValues();
    }

    getElementContainer() {
        let el = document.querySelector(this.selector);
        if (!el) {
            // Build list of selectors to try: new pattern first, then legacy patterns
            // New pattern: #wc-{gateway_id}-{context}-button
            // Old pattern: #wc-{gateway_id}-container
            const gatewayId = this.gateway.id;
            const gatewayIdHyphenated = gatewayId.replace(/_/g, '-');

            const queries = [
                // New class pattern
                `#wc-${gatewayId}-cart-button`,
                `#wc-${gatewayIdHyphenated}-cart-button`,
                // Legacy ID patterns with -container suffix
                `#wc-${gatewayIdHyphenated}-container`
            ];

            for (const query of queries) {
                el = document.querySelector(query);
                if (el) {
                    this.selector = query;
                    return super.getElementContainer();
                }
            }
        }
        return super.getElementContainer();
    }

}

export default CartController;